//
//
//
//
//
//
//

import product from './components/visualization';
import tableData from './components/tableData';
export default {
  components: {
    product: product,
    tableData: tableData
  }
};